// Единый источник SEO-страниц: отсюда берут и мета SPA (src/i18n/languages/ru.js),
// и пререндер для роботов (scripts/generate-seo.js). Дублировать тексты нельзя —
// иначе мета статики и приложения разъезжается, а это ровно тот дубль, из-за
// которого Вебмастер схлопывал страницы. Общий каркас страницы (head, header,
// footer, счётчики) лежит в scripts/seo-template.js, здесь — только уникальное.
//
// Формат CommonJS осознанный: файл читают и webpack, и обычный node-скрипт
// сборки. На Дереве генератор запускается через tsx, у нас Node 16 и TS нет.
//
// Страницы без пререндера (кабинет, оплата, юридические) меты здесь не имеют —
// они остаются в i18n как были.

const {
  SITE,
  DEFAULT_OG_IMAGE,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_ALT
} = require('./site')

// Номиналы — с живых страниц. Цены здесь не хранятся: их забирает на сборке
// scripts/seo-prices.js и подставляет на место токена {{PRICES}}. Эти массивы —
// запасной вариант: если API недоступен, в списке остаются одни номиналы, без
// рублей. Вмёрзшая в статику цена обманывала бы и робота, и человека в сниппете.
const TRANSFER_PRESETS = [20, 60, 120, 300]
// Номиналы гифт-карт — из /keys_stock. Тут был список, снятый с экрана вместе с
// ценами, и в нём оказался несуществующий номинал 400 (это была цена, а не R$).
const GIFT_PRESETS = [199, 300, 500, 800, 1000, 1500, 2000, 4500, 10000]
const PACKS_PRESETS = [
  80,
  160,
  240,
  320,
  500,
  740,
  820,
  1000,
  1240,
  1740,
  2240,
  3000,
  4000,
  5000,
  7000,
  8000,
  10000,
  14000,
  16000,
  20000,
  22500
]

const { breadcrumbs } = require('./jsonLd')

// Текст юридических документов — тот же массив абзацев, что рендерит SPA
// (src/i18n/languages/ru.js). Пререндеру нужен именно он: страница с одним
// заголовком и пустотой вместо документа — это не то, что видит человек, а
// расхождение робота с пользователем мы держим на нуле по всему сайту.
const policy = require('../i18n/policy/ru')
const terms = require('../i18n/terms/ru')

// Абзацы приходят с ведущим переводом строки и уже содержат <b> для
// подзаголовков — отдаём как есть, экранировать нечего: это наш собственный
// текст, а не пользовательский ввод.
const paragraphs = items =>
  items
    .map(text => text.trim())
    .filter(Boolean)
    .map(text => `      <p>${text}</p>`)
    .join('\n')

/**
 * Страница пререндера.
 * url — путь роутинга, он же ключ nginx-мапы. Без url страница генерится, но
 *       боту по адресу не отдаётся (404 приходит через error_page).
 * file — имя файла в public/seo.
 * h1 — заголовок страницы. Тот же, что рендерит SPA: берётся из i18n.
 * ogTitle — заголовок карточки в соцсетях, если он отличается от title. В
 *       выдаче title обязан содержать запрос («купить робуксы Роблокс дёшево»),
 *       а в мессенджере такой заголовок читается как спам — там нужен короткий.
 *       Не задан — карточка берёт title, так по таблице копирайта у всех
 *       страниц, кроме четырёх витрин.
 * main — курированный слепок содержимого страницы.
 */
const SEO_PAGES = [
  {
    file: '404.html',
    title: 'Страница не найдена (404) | RbxPier.me',
    description: 'К сожалению, запрашиваемая страница не найдена. Попробуйте вернуться на главную страницу.',
    h1: 'Упс, страница не найдена…',
    // Без canonical: ссылка на главную противоречит noindex, и Яндекс из-за
    // неё держит битые адреса в группах дублей вместо того, чтобы выбросить.
    noindex: true,
    noFooter: true,
    main: `
    <section>
      <p>Попробуйте перезагрузить страницу или вернитесь на главную сайта.</p>
      <p><a href="/">Вернуться на главную</a></p>
    </section>`
  },
  {
    url: '/',
    file: 'index.html',
    title: 'Купить робуксы Роблокс на RbxPier.me по низкой цене',
    description:
      'Подарочные карты Роблокс и робукс трансфер быстро, дёшево и безопасно. Надёжный сайт с реальными отзывами. ' +
      'Не упусти акции Пристани Робуксов!',
    h1: 'Купить робуксы Роблокс',
    main: `
    <h2>Купить робуксы легко!</h2>

    <section>
      <h2>Выбери метод покупки</h2>

      <article>
        <h3><a href="/giftcards">Покупка подарочной карты</a></h3>
        <p>Мгновенная доставка</p>
        <p>Можно подарить другу</p>
      </article>

      <article>
        <h3><a href="/transfer">Покупка методом трансфер</a></h3>
        <p>Классический метод</p>
        <p>Дешёвые робуксы</p>
      </article>

      <article>
        <h3><a href="/superpass">Покупка Супер-пасса</a></h3>
        <p>Мгновенная доставка</p>
        <p>Пассы для Роблокса</p>
      </article>

      <article>
        <h3><a href="/packs">Покупка робукс пака</a></h3>
        <p>Робуксы мгновенно</p>
        <p>Надёжно и безопасно</p>
      </article>
    </section>

    <section>
      <h2>Пристань Робуксов</h2>
      <p>400+ тысяч клиентов, всегда лучший курс, выполняем быстро каждый заказ.</p>
      <p>Нас проверили блогеры и время! Стараемся ради каждого пользователя.</p>
    </section>

    <section>
      <h2>Возникли вопросы по покупке?</h2>
      <p>Онлайн-поддержка с живыми операторами поможет вам ежедневно с 7:00 до 23:00 по московскому времени. Для обращения нажмите на виджет поддержки в правом нижнем углу экрана.</p>
    </section>`
  },
  {
    url: '/transfer',
    file: 'transfer.html',
    title: 'Купить робуксы Роблокс дёшево на RbxPier.me',
    description:
      'Покупай робуксы для Роблокс методом трансфер моментально и безопасно на RbxPier.me. Выгодный курс, промокоды и живая поддержка.',
    h1: 'Робуксы методом Трансфер',
    ogTitle: 'Робуксы Роблокс методом Трансфер',
    jsonLd: [
      breadcrumbs([
        { name: 'Главная', url: '/' },
        { name: 'Трансфер', url: '/transfer' }
      ])
    ],
    product: {
      name: 'Робуксы Roblox — метод Трансфер',
      prices: { from: 'rate', rateKey: 'transfer_rate', presets: TRANSFER_PRESETS }
    },
    main: `
    <section>
      <h2>Установите количество робуксов</h2>
      <p>Срок поступления робуксов на счёт — 5 дней.</p>
      <p>Минимум от 20 R$.</p>
{{PRICES}}
      <p>У меня есть промокод</p>
      <p>Где взять промокод?</p>
    </section>

    <section>
      <h2>Введите никнейм Roblox</h2>
      <p>Укажите никнейм и выберите персонажа из игры Roblox.</p>
    </section>

    <section>
      <h2>Оплатите заказ</h2>
      <p>Выберите платёжный метод и оплатите заказ. Доступны СБП, банковские карты и оплата с баланса.</p>
    </section>`
  },
  {
    url: '/giftcards',
    file: 'giftcards.html',
    title: 'Купить подарочные карты Роблокс на RbxPier.me по низкой цене',
    description:
      'Покупай подарочные карты Роблокс быстро и безопасно на RbxPier.me. Надёжный способ пополнения с мгновенной активацией и быстрой поддержкой.',
    h1: 'Подарочные карты Роблокс',
    ogTitle: 'Подарочные карты Роблокс',
    jsonLd: [
      breadcrumbs([
        { name: 'Главная', url: '/' },
        { name: 'Подарочные карты', url: '/giftcards' }
      ])
    ],
    // Гифт-карта — товар штучный: номиналы и цены приходят из стока, по курсу
    // их не посчитать. Пресеты остаются запасным списком на случай, если API лёг.
    product: {
      name: 'Подарочные карты Roblox',
      prices: { from: 'keys', presets: GIFT_PRESETS }
    },
    main: `
    <section>
      <h2>Выберите количество робуксов</h2>
      <p>Моментальная доставка!</p>
{{PRICES}}
    </section>

    <section>
      <h2>Оплатите заказ</h2>
      <p>Выберите платёжный метод и оплатите заказ. Код подарочной карты придёт сразу после оплаты.</p>
    </section>`
  },
  {
    url: '/superpass',
    file: 'superpass.html',
    title: 'Купить пассы для игр в Роблокс на RbxPier.me по низкой цене',
    description:
      'Покупай пассы для игр в Роблокс без ожидания. Моментальная выдача, выгодные цены и быстрая поддержка.',
    h1: 'Пассы для игр в Роблокс',
    ogTitle: 'Пассы для игр в Роблокс',
    jsonLd: [
      breadcrumbs([
        { name: 'Главная', url: '/' },
        { name: 'Суперпассы', url: '/superpass' }
      ])
    ],
    // Без prices и без токена {{PRICES}}: на странице сначала выбирают игру, и
    // единого прайса там не показано. Product с ценами противоречил бы видимому
    // содержимому, а это повод для ручной санкции.
    product: { name: 'Супер-пасс Roblox' },
    main: `
    <section>
      <h2>Выбери игру</h2>
      <p>Нет нужной игры? Обратись в поддержку.</p>
    </section>

    <section>
      <h2>Выбери пасс</h2>
      <p>Укажите никнейм Roblox и выберите пасс с нужным количеством робуксов.</p>
    </section>

    <section>
      <h2>Оплатите заказ</h2>
      <p>Выберите платёжный метод и оплатите заказ. Робуксы зачисляются мгновенно.</p>
    </section>`
  },
  {
    url: '/packs',
    file: 'packs.html',
    title: 'Купить паки робуксов на RbxPier.me по низкой цене',
    description: 'Покупай паки робуксов через метод ЛогПасс. Мгновенная обработка заказа и безопасная оплата.',
    h1: 'Паки робуксов',
    ogTitle: 'Паки робуксов Роблокс',
    jsonLd: [
      breadcrumbs([
        { name: 'Главная', url: '/' },
        { name: 'Паки', url: '/packs' }
      ])
    ],
    product: {
      name: 'Робукс паки Roblox',
      prices: { from: 'catalog', category: 'robux', presets: PACKS_PRESETS }
    },
    main: `
    <section>
      <h2>Выберите количество робуксов</h2>
      <p>Готовые пакеты робуксов по фиксированной цене.</p>
{{PRICES}}
    </section>

    <section>
      <h2>Введите никнейм Roblox</h2>
      <p>Укажите никнейм аккаунта, на который зачислить робуксы.</p>
    </section>

    <section>
      <h2>Оплатите заказ</h2>
      <p>Выберите платёжный метод и оплатите заказ. Доступна оплата с баланса и пополнение любым способом.</p>
    </section>`
  }
]

// Юридические страницы. Пререндер у них появился в RBXGD-1114: до этого они
// стояли в sitemap, то есть были заявлены к индексации, но роботу без
// исполнения JS приходил SPA-скелет с заголовком главной и без canonical —
// ровно та картина, из-за которой Яндекс выбрасывал их как DUPLICATE.
//
// priority ниже, чем у витрин: это документы, а не точки входа.
const LEGAL_PAGES = [
  {
    url: '/privacy',
    file: 'privacy.html',
    priority: '0.3',
    title: 'Политика конфиденциальности RbxPier.me',
    description:
      'Ознакомьтесь с политикой конфиденциальности RbxPier.me: условия обработки персональных данных, использование cookies и права пользователей.',
    h1: 'Политика конфиденциальности',
    jsonLd: [breadcrumbs([{ name: 'Главная', url: '/' }, { name: 'Политика конфиденциальности', url: '/privacy' }])],
    main: `
    <section>
${paragraphs(policy)}
    </section>`
  },
  {
    url: '/termsofuse',
    file: 'termsofuse.html',
    priority: '0.3',
    title: 'Пользовательское соглашение RbxPier.me',
    description:
      'Ознакомьтесь с условиями использования сайта RbxPier.me: права и обязанности пользователей и оператора, порядок вступления соглашения в силу.',
    h1: 'Пользовательское соглашение',
    jsonLd: [
      breadcrumbs([{ name: 'Главная', url: '/' }, { name: 'Пользовательское соглашение', url: '/termsofuse' }])
    ],
    main: `
    <section>
${paragraphs(terms)}
    </section>`
  },
  {
    url: '/contacts',
    file: 'contacts.html',
    priority: '0.3',
    title: 'Документы и контакты на RbxPier.me',
    description:
      'Ознакомьтесь с документами сайта RbxPier.me и получите контактную информацию: адрес, email и социальные сети. Прозрачность для каждого пользователя.',
    h1: 'Документы и контакты',
    jsonLd: [breadcrumbs([{ name: 'Главная', url: '/' }, { name: 'Контакты', url: '/contacts' }])],
    // Слепок того, что показывает Contacts.vue.
    main: `
    <section>
      <h2>Контакты</h2>
      <ul>
        <li>rbxpier.me</li>
        <li>EPIK582@gmail.com</li>
        <li><a href="https://vk.com/ROBUXPIER">vk.com/ROBUXPIER</a></li>
      </ul>
    </section>`
  }
]

SEO_PAGES.push(...LEGAL_PAGES)

// Что попадает в sitemap.xml: витрины из реестра плюс список выше. Закрытые от
// индексации (404) и страницы под авторизацией сюда не входят по построению —
// первых отсекает noindex, вторых просто нет в реестре.
const sitemapPages = () =>
  SEO_PAGES.filter(page => page.url && !page.noindex).map(page => ({
    url: page.url,
    // Свой priority у юридических страниц, иначе вес витрины.
    priority: page.priority || (page.url === '/' ? '1.0' : '0.8')
  }))

/**
 * Постраничные блоки микроразметки по пути — для App.vue. Ищем и среди страниц
 * с пререндером, и среди SPA-only: у первых блоки те же, что уходят в статику,
 * поэтому приложение и робот видят одно и то же.
 */
function jsonLdFor(url) {
  const page = byUrl.get(url)

  return (page && page.jsonLd) || []
}

const byUrl = new Map(SEO_PAGES.filter(page => page.url).map(page => [page.url, page]))
const byFile = new Map(SEO_PAGES.map(page => [page.file, page]))

// ogTitle кладём в словарь только когда он задан: vue-i18n на отсутствующее
// значение возвращает сам ключ, и в карточке оказалась бы строка
// «app.privacy.ogTitle». Роут спрашивает про ключ через $te, см. App.vue.
const pick = page => {
  const meta = { title: page.title, description: page.description, h1: page.h1 }

  if (page.ogTitle) meta.ogTitle = page.ogTitle

  return meta
}

/** Мета страницы по её пути — для i18n. */
function seoMeta(url) {
  const page = byUrl.get(url)
  if (!page) throw new Error(`SEO: нет страницы с url ${url}`)
  return pick(page)
}

/** То же для страниц без пути (404 отдаётся через error_page). */
function seoMetaByFile(file) {
  const page = byFile.get(file)
  if (!page) throw new Error(`SEO: нет страницы с файлом ${file}`)
  return pick(page)
}

module.exports = {
  SITE,
  DEFAULT_OG_IMAGE,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
  OG_IMAGE_ALT,
  SEO_PAGES,
  sitemapPages,
  jsonLdFor,
  seoMeta,
  seoMetaByFile
}
